<template>
    <div class="gallery-card flex relative" v-lazyload>
        <div class="skeleton skeleton-loading sm-col-6" @click="navigate()" :data-url="thumbnail"></div>
        <img class="sm-col-6 image__item" style="object-fit: cover;" @click="navigate()" :data-url="thumbnail"/>
        <div class="sm-col-6 p2 py3 border-box flex flex-column justify-between gallery-card--text-box">
            <div>
                <h2 class="h1 bold mb1">{{title}}</h2>
                <p class="h3 regular mb1">Vom {{fancyDate}}</p>
                <!-- <p class="h4 light color-gray mb3">100 Bilder</p> -->
            </div>
            <router-link class="btn btn-primary" :to="'/gallery/' + galleryid + '/' + picid">Ansehen</router-link>
        </div>
    </div>
</template>

<script>


export default {
  name: "GalleryCard",
  data() {
    return {
        picid: 0,
    };
  },
  props: {
      galleryid: String,
      title: String,
      description: String, 
      thumbnail: String,
      images: Array,
      created_at: String
  },
  computed: {
      fancyDate(){
        var year = this.created_at.slice(0, 4)
        var month = this.created_at.slice(5, 7)
        var day = this.created_at.slice(8, 10)
        return day + '.' + month + '.' + year
      }
  },

  components: {

  },
  methods: {
      navigate(){
          this.$router.push({ path: '/gallery/' + this.galleryid + '/' + this.picid })
      }
  },
  mounted() {
  }
};
</script>
<style scoped>

</style>